enum MODAL_TYPE {
  CONFIRM = 'CONFIRM',
  DELETE = 'DELETE',
  FORM = 'FORM',
}

export default MODAL_TYPE;
